import gql from "graphql-tag";

export const UpdateItemGroupDailyPageView = gql`
mutation($input: UpdateItemGroupDailyPageViewInput!) {
  updateItemGroupDailyPageView(input: $input ) {
    errors {
      model
      attribute
      message
    }
  }
}
`
